export const common = {
  // Navigation
  home: 'Ana Sayfa',
  product: 'Ürün',
  applications: 'Uygulamalar',
  aboutUs: 'Hakkımızda',
  contact: 'İletişim',
  
  // Common Actions
  learnMore: 'Daha Fazla Bilgi',
  getStarted: 'Başlayın',
  contactUs: 'Bize Ulaşın',
  sendMessage: 'Mesaj Gönder',
  sending: 'Gönderiliyor...',
  
  // Footer
  quickLinks: 'Hızlı Bağlantılar',
  ourProduct: 'Ürünümüz',
  followUs: 'Bizi Takip Edin',
  poweredBy: 'Readdy ile güçlendirilmiştir',
  allRightsReserved: 'Tüm hakları saklıdır.',
  footerDescription: 'İnşaat sektörü için çelik donatı teli güçlendirmede mühendislik mükemmelliği.',
  hookedEndSteelFibers: 'Kancalı Uçlu Çelik Donatı Telleri',
  websiteBuilder: 'Web Sitesi Oluşturucu',
  
  // Contact
  address: 'Adres',
  phone: 'Telefon',
  email: 'E-posta',
  whatsapp: 'WhatsApp',
  instagram: 'Instagram',
  
  // Form
  fullName: 'Ad Soyad',
  companyName: 'Şirket Adı',
  emailAddress: 'E-posta Adresi',
  phoneNumber: 'Telefon Numarası',
  message: 'Mesaj',
  required: '*',
  characters: 'karakter',
  
  // Messages
  successMessage: 'Teşekkürler! Mesajınız başarıyla gönderildi. En kısa sürede size geri döneceğiz.',
  errorMessage: 'Üzgünüz, mesajınız gönderilirken bir hata oluştu. Lütfen tekrar deneyin veya doğrudan bizimle iletişime geçin.',
};
